import React from "react";
import { format } from "date-fns";
//limitless imports
import Typography from "@limitless/modern/data-display/typography/Typography";
import { BoxRenderer } from "@limitless/portal";
import { aiStar } from "@limitless/images";
import IconButton from "@limitless/modern/inputs/icon-button/IconButton";

export const renderDateCell = date => {
    return <Typography variant="caption"> {format(date, "DD/MM/YYYY")}</Typography>;
};
const GenAiReviewIcon = () => (
    <IconButton
        icon={<img src={aiStar} alt="Review performed by an AI Expert" style={{ width: 20, height: 20 }} />}
        label="This review was performed by an AI Expert"
        style={{
            position: "absolute",
            transform: "translateX(-100%) translateY(-70%)",
            zIndex: 1
        }}
    />
);
const renderBoxCell = (value, showIcon = false) => {
    return (
        <BoxRenderer
            fontSize={12}
            fontWeight={400}
            value={`${value}%`}
            color={value >= 80 ? "secondary-main" : value >= 50 ? "warning-light" : "error-light"}
            variant="caption"
            showRadius
            centerTextAlign
            fullBoxWidth
            containerStyles={{ padding: "4px 12px", position: "relative" }}
        >
            {showIcon && <GenAiReviewIcon />}
        </BoxRenderer>
    );
};

const renderCommonCell = (value, showIcon = false) => {
    return (
        <Typography
            variant="caption"
            sx={{ display: "block", textAlign: "center" }}
            color={theme => (value >= 50 ? theme.palette.primary.dark : theme.palette.error.dark)}
        >
            {showIcon && <GenAiReviewIcon />}
            {`${value}%`}
        </Typography>
    );
};

export const RATING_COLUMNS = [
    {
        name: "date",
        label: "Date",
        options: {
            customBodyRender: v => renderDateCell(v),
            setCellProps: () => ({ style: { width: "120px" } })
        }
    },
    {
        name: "displayName",
        label: "Group",
        options: {
            setCellProps: () => ({ style: { width: "300px" } })
        }
    },
    {
        name: "custRating",
        label: "Customer Rating",
        options: {
            customBodyRender: (v, tableMeta) =>
                v !== null &&
                v !== 0 &&
                (tableMeta.rowData[5] !== null && tableMeta.rowData[6]?.includes("customer")
                    ? renderBoxCell(v)
                    : renderCommonCell(v)),
            setCellProps: () => ({ style: { width: "160px" } }),
            setCellHeaderProps: () => ({ style: { textAlign: "center" } })
        }
    },
    {
        name: "reviewScore",
        label: "Quality Rating",
        options: {
            customBodyRender: (v, tableMeta) => {
                const isGenaiReview = tableMeta.rowData[7] ?? false;
                const includedInRating = tableMeta.rowData[5] !== null;
                const ratingType = tableMeta.rowData[6] ?? "";

                if (v === null || v === 0) {
                    return null;
                }

                if (includedInRating && ratingType.includes("review")) {
                    return renderBoxCell(v, isGenaiReview);
                }

                if (includedInRating && ratingType.includes("qualityReviewRating")) {
                    return renderCommonCell(v, isGenaiReview);
                }

                return renderCommonCell(v);
            },

            setCellProps: () => ({ style: { width: "160px" } }),
            setCellHeaderProps: () => ({ style: { textAlign: "center" } })
        }
    },
    {
        name: "messageId",
        label: "messageId",
        options: {
            display: false
        }
    },
    {
        name: "includedInRating",
        label: "includedInRating",
        options: {
            display: false
        }
    },
    {
        name: "ratingType",
        label: "ratingType",
        options: {
            display: false
        }
    },
    {
        name: "isGenaiReview",
        label: "isGenaiReview",
        options: {
            display: false
        }
    }
];
